'use strict';

var React = require('react');

const PortalsManagerContext = /*#__PURE__*/React.createContext(undefined);

exports.PortalsManagerContext = PortalsManagerContext;
